import { type VariantProps, cva } from 'class-variance-authority'

export const alertVariants = cva(
	'flex w-full items-center gap-2 rounded-lg p-3 text-sm [&>svg]:size-5 [&>svg]:shrink-0',
	{
		variants: {
			variant: {
				default: 'bg-background text-foreground',
				destructive: 'bg-destructive text-destructive-foreground',
				informative: 'bg-informative text-informative-foreground',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
)

export type AlertVariants = VariantProps<typeof alertVariants>
